import { Flex, Box } from 'rebass/styled-components'
import { IonIcon, IonButton } from '@ionic/react'
import { addCircleOutline } from 'ionicons/icons'

export default (props) => (
    <Flex {...props} alignItems="center" justifySelf="center" color="primary">
        <IonIcon icon={addCircleOutline} size="large" />
    </Flex>
)

// const PlusBtn = ({ size, ...props }) => (
//     <Flex
//         justifyContent="center"
//         alignItems="center"
//         flex="none"
//         sx={{
//             border: '1px solid #eee',
//             bg: 'primary',
//             color: 'white',
//             borderRadius: '50%',
//             width: size,
//             height: size,
//         }}
//         {...props}
//     >
//         <FaPlus></FaPlus>
//     </Flex>
// )

// export default PlusBtn
